// import { GlobalState } from '@leverege/ui-redux'

export default { 
  name : 'Globalstar Subscription Status',
  objectType : 'boat',
  valueType : 'string',
  displayName : 'Globalstar Subscription Status',
  get : () => null
  // this mostly works but can break due to execution order, so keeping the renderer is more appropriate
  // get : () => GlobalState.get()?.ui?.globalstarSubscriptionInfo?.anniversaryDate ? 'Valid' : null
}
